import XAPPService from 'app/Core/services/XAPPService';
import _ from 'lodash';

export const GET_EMPRESAGRUPOPRODUTOS = '{EMPRESAGRUPOPRODUTO APP] GET CONTAS';
export const GET_EMPRESAGRUPOPRODUTO = '{EMPRESAGRUPOPRODUTO APP] GET CONTA';
export const GET_TEMPLATE = '{EMPRESAGRUPOPRODUTO APP] GET TEMPLATE';

export const OPEN_NEW_EMPRESAGRUPOPRODUTO_DIALOG = '{EMPRESAGRUPOPRODUTO APP] OPEN NEW CONTA DIALOG';
export const CLOSE_NEW_EMPRESAGRUPOPRODUTO_DIALOG = '{EMPRESAGRUPOPRODUTO APP] CLOSE NEW CONTA DIALOG';
export const OPEN_EDIT_EMPRESAGRUPOPRODUTO_DIALOG = '{EMPRESAGRUPOPRODUTO APP] OPEN EDIT CONTA DIALOG';
export const CLOSE_EDIT_EMPRESAGRUPOPRODUTO_DIALOG = '{EMPRESAGRUPOPRODUTO APP] CLOSE EDIT CONTA DIALOG';

export const EMPRESAGRUPOPRODUTO_REMOVE = '{EMPRESAGRUPOPRODUTO APP] CONTA REMOVE';
export const ADD_EMPRESAGRUPOPRODUTO = '{EMPRESAGRUPOPRODUTO APP] ADD CONTA';

export const EMPRESAGRUPOPRODUTO_WARNING = '{EMPRESAGRUPOPRODUTO APP] CONTA WARNING';
export const EMPRESAGRUPOPRODUTO_INFO = '{EMPRESAGRUPOPRODUTO APP] CONTA INFO';
export const EMPRESAGRUPOPRODUTO_ERROR = '{EMPRESAGRUPOPRODUTO APP] CONTA ERROR';
export const EMPRESAGRUPOPRODUTO_SELECIONAR_WARNING = '{EMPRESAGRUPOPRODUTO APP] CONTA SELECIONAR WARNING';
export const EMPRESAGRUPOPRODUTO_SELECIONAR_INFO = '{EMPRESAGRUPOPRODUTO APP] CONTA SELECIONAR INFO';
export const EMPRESAGRUPOPRODUTO_SELECIONAR_ERROR = '{EMPRESAGRUPOPRODUTO APP] CONTA SELECIONAR ERROR';

const ListState =
    [
        'idpessoaformulario',
        'idpessoa',
        'idparent',
        'nome',
        'tipogrupo',
        'tipogrupodescricao',
        'tipo',
        'formulario',
        'statusregistro',
        'statusregistrodescricao',
        'usrins',
        'usrupt',
        'datainsdescricao',
        'datauptdescricao',
        'totalrows',
        'paginas',
    ];

const AddState =
    [
        'idparent',
        'formulario',
        'idpessoa',
        'tipo',
    ];

const UpdateState =
    [
        'formulario',
        'idparent',
    ];

export function get(_AIDPessoaFormulario, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "GrupoProdutos", AActions, "spvwempresagrupoproduto", ListState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAGRUPOPRODUTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAGRUPOPRODUTO_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter = null, _APagina = 1, _ATarget = null, _ACallback = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var ATarget = !_.isNull(_ATarget) ? _ATarget : "spvwempresagrupoproduto";

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "GruposProduto", AActions, ATarget, ListState, _AAction, AConditionsAND, AConditionsOR, _APagina)

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAGRUPOPRODUTOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                ]);
                if (!_.isNull(_ACallback)) {
                    _ACallback();
                }
            }
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAGRUPOPRODUTO_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESAGRUPOPRODUTO_DIALOG
    }
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_EMPRESAGRUPOPRODUTO_DIALOG
    }
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_EMPRESAGRUPOPRODUTO_DIALOG,
        data
    }
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_EMPRESAGRUPOPRODUTO_DIALOG
    }
}

export function save(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, UpdateState);

        }
        else {
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, AddState);
        }


        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAGRUPOPRODUTO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback()
                        }
                    })
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAGRUPOPRODUTO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback()
                        }
                    })
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESAGRUPOPRODUTO_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplate() {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction('pessoa', "136")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TEMPLATE,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAGRUPOPRODUTO_SELECIONAR_ERROR,
                    payload: error
                });
            });;
    }
}

export function acaoRegistro(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", _AAction, "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: EMPRESAGRUPOPRODUTO_REMOVE
                    })
                ]).then(() => {
                    if (!_.isNull(_ACallback)) {
                        _ACallback()
                    }
                })
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAGRUPOPRODUTO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_EMPRESAGRUPOPRODUTOS,
        data: null,
        pagina: 1,
    }
}